import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './statusMessage.css';

class StatusMessage extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          {this.props.messageType === 'success' && (
            <>
              <h1 className={styles.title}>You did it!</h1>
              <p className={styles.text}>
                View the entire community of creations{' '}
                <a
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.are.na/upstatement/the-art-direction-show-inspiration-machine-creations">
                  here
                </a>
                .
              </p>
            </>
          )}
          {this.props.messageType === 'error' && (
            <>
              <h1 className={styles.title}>Oh No!</h1>
              <p className={styles.text}>There has been an error. Try again?</p>
            </>
          )}
          <button onClick={this.props.resetCanvas} className={styles.button}>
            Draw Again
          </button>
        </div>
      </div>
    );
  }
}

StatusMessage.propTypes = {
  resetCanvas: PropTypes.func,
  messageType: PropTypes.string,
};

export default StatusMessage;
